import Rest from '../Rest'

export default class MySubscriptionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/my_subscriptions'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  cancel(id: number, cancellationReason?: string) {
    return this.post(`/${id}/cancel`, { cancellation_reason: cancellationReason })
  }

  find(id: number) {
    return this.read(id)
  }
}
